import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=b9a851d8&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./Main.vue?vue&type=style&index=0&id=b9a851d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a851d8",
  null
  
)

export default component.exports